import React from 'react';
import './Header.css';

const SCREEN_TITLES = {
  home:      'BULLIVO',
  signale:   'Signale',
  news:      'News',
  watchlist: 'Watchlist',
  whales:    'Big Money',
  analyse:   'Analyse',
};

function GearIcon() {
  return (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="3"/>
      <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/>
    </svg>
  );
}

function SearchIcon() {
  return (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="11" cy="11" r="7"/>
      <line x1="21" y1="21" x2="16.65" y2="16.65"/>
    </svg>
  );
}

function AppHeader({ activeTab, onOpenSettings, onOpenWatchlistSearch }) {
  const title  = SCREEN_TITLES[activeTab] || 'BULLIVO';
  const isHome = activeTab === 'home';
  const showSearch = activeTab === 'watchlist' && typeof onOpenWatchlistSearch === 'function';

  return (
    <header className="app-header">
      <div className="app-header-leading">
        {showSearch && (
          <button className="app-header-gear" onClick={onOpenWatchlistSearch} aria-label="Asset suchen">
            <SearchIcon />
          </button>
        )}
      </div>
      <span className={`app-header-title ${isHome ? 'brand' : 'screen'}`}>
        {title}
      </span>
      <div className="app-header-actions">
        <button className="app-header-gear" onClick={onOpenSettings} aria-label="Einstellungen">
          <GearIcon />
        </button>
      </div>
    </header>
  );
}

export default AppHeader;
